import { SeekerService } from '../../../shared/services/seeker.service';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTable, DataTableTranslations } from 'angular-datatables-all-versions';
import { ToastyService } from 'ng2-toasty';
import * as moment from 'moment';

@Component({
  selector: 'app-seekers-list',
  templateUrl: './seekers-list.component.html',
  styleUrls: ['./seekers-list.component.css']
})
export class SeekersListComponent implements OnInit {
  @ViewChild('search_input',{static:true}) searchInputRef: ElementRef;
  @ViewChild('search_btn',{static:true}) searchBtnRef: ElementRef;
  @ViewChild(DataTable,{static:true}) userTable: DataTable;

  translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  };

  public seekers: any = [];
  public seekerCount: any = 0;
  public eventParams: any;
  public limits = [25, 50, 100];

  constructor(
    private toastyService: ToastyService,
    private service: SeekerService,
    private modalService: NgbModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {}

  cellColor(car) {
    return (
      'rgb(255, 255,' +
      (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) +
      ')'
    );
  }

  reload(event) {
    let finalEvent = {...event};
    // To prevent internal error when the current page number < 1
    if(this.userTable.page<1) {
      // this.userTable.page = 1;
      finalEvent.offset = 0;
    }

    this.eventParams = finalEvent;
    this.service.find(finalEvent).subscribe(data => {
      this.seekerCount = data.meta.pagination.total_objects;
      this.seekers = data.seekers;
    });
  }

  onExportData() {
    this.service.find(this.eventParams).subscribe((data: any) => {
      const exportdata: any[] = [];
      data.seekers.forEach(item => {
        exportdata.push({
          Société: item.society,
          Prénom: item.firstname,
          Nom: item.name,
          'Adresse e-mail': item.email,
          Phone: item.contact_number ? item.contact_number : '',
          'Date création': moment(item.created_at).format('DD/MM/YYYY')
        });
      });
      const csvData = this.convertToCSV(exportdata);
      const blob = new Blob([csvData], { type: 'text/csv' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, 'Demandeurs.csv');
      } else {
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'Demandeurs.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => (value === null ? '' : value);
    const header = Object.keys(objArray[0]);
    let csv = objArray.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(';')
    );
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n');
    return csv;
  }
}
